/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';

const actions = {
  postImport({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/users/import`, { ...payload.data });
  },
};

export default { namespaced: true, actions };



// WEBPACK FOOTER //
// ./src/store/modules/users/import.js